export const formatPostcode = (postcode: string): string => {
    let formattedPostCode = postcode.toUpperCase();
    formattedPostCode = formattedPostCode.replace(/[^0-9a-z]/gi, '');
    const parts = formattedPostCode.match(/^([A-Z]{1,2}\d{1,2}[A-Z]?)\s*(\d[A-Z]{2})$/);

    if (parts) {
        parts?.shift();
        formattedPostCode = parts.join(' ');
    }

    return formattedPostCode;
};
